var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99999 1.33325C5.05447 1.33325 2.66666 4.00164 2.66666 6.99992C2.66666 9.9747 4.36887 13.2082 7.0247 14.4495C7.64382 14.7389 8.35616 14.7389 8.97528 14.4495C11.6311 13.2082 13.3333 9.9747 13.3333 6.99992C13.3333 4.00164 10.9455 1.33325 7.99999 1.33325ZM7.99999 7.99992C8.73637 7.99992 9.33332 7.40297 9.33332 6.66659C9.33332 5.93021 8.73637 5.33325 7.99999 5.33325C7.26361 5.33325 6.66666 5.93021 6.66666 6.66659C6.66666 7.40297 7.26361 7.99992 7.99999 7.99992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationWhite);
export default __webpack_public_path__ + "static/media/location-white.e53a984319401dc295c49227f550ddcd.svg";
export { ForwardRef as ReactComponent };